












































































import { Vue, Component } from 'vue-property-decorator'
import { getThumbUrl } from '@/utils/thumbnail'

const PY_LABELS: Record<string, string> = {
    '45': '20평형',
    '46': '30평형',
    '47': '40평형',
    '48': '50평형~'
}

@Component
export default class Apartments extends Vue {
    apartments: any[] = []
    getThumbUrl = getThumbUrl
    loading = false
    savingSort = false
    isSortedChanged = false
    activePy = ''
    pyFilters = [
        { value: '', label: '전체' },
        { value: '45', label: '20평형' },
        { value: '46', label: '30평형' },
        { value: '47', label: '40평형' },
        { value: '48', label: '50평형~' }
    ]

    async created () {
        await this.loadList()
    }

    selectPy (py: string) {
        if (this.activePy === py) return
        this.activePy = py
        this.loadList()
    }



    async loadList () {
        this.loading = true
        try {
            const list = await this.$store.dispatch('adminApartmentList', this.activePy)
            this.apartments = Array.isArray(list) ? list : []
            this.isSortedChanged = false
        } catch (e) {
            this.apartments = []
        } finally {
            this.loading = false
        }
    }

    moveUp (index: number) {
        if (index <= 0) return
        const temp = this.apartments[index]
        this.$set(this.apartments, index, this.apartments[index - 1])
        this.$set(this.apartments, index - 1, temp)
        this.isSortedChanged = true
    }

    moveDown (index: number) {
        if (index >= this.apartments.length - 1) return
        const temp = this.apartments[index]
        this.$set(this.apartments, index, this.apartments[index + 1])
        this.$set(this.apartments, index + 1, temp)
        this.isSortedChanged = true
    }

    async saveSort () {
        this.savingSort = true
        try {
            const ids = this.apartments.map(apt => apt.id)
            await this.$store.dispatch('updateApartmentSort', ids)
            alert('순서가 성공적으로 저장되었습니다.')
            this.isSortedChanged = false
            await this.loadList()
        } catch (e) {
            alert('순서 저장 중 오류가 발생했습니다.')
        } finally {
            this.savingSort = false
        }
    }

    pyLabel (py: string): string {
        return PY_LABELS[String(py)] || py || ''
    }

    goEdit (id: string | number) {
        this.$router.push({ name: 'adminApartmentEdit', query: { id: String(id) } })
    }

    async remove (apt: any) {
        if (!window.confirm(`'${apt.name}'을(를) 삭제하시겠습니까?`)) return
        try {
            await this.$store.dispatch('deleteApartment', apt.id)
            await this.loadList()
        } catch (e) {
            alert('삭제 중 오류가 발생했습니다.')
        }
    }
}
